const urls = {
  urlPayWay: "https://api.payway.com.au/rest/v1/payway.js",
};

export default urls;
